<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <!-- 부가정보 : 운전자 자격정보-->
    <write-grid-container title="운전자 자격정보" v-model="form.subInfo" :options="gridContainerOptions">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div class="print-input" v-if="dataType === 'date'">{{ form.subInfo[value] }}</div>
          <div class="print-input" v-else>{{ form.subInfo[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <FileUploader v-if="dataType === 'file'" class="w-full" v-model="form.subInfo[value]" />
          <custom-option-selector v-else-if="dataType === 'selector'" class="w-full" v-model="form.subInfo[value]" :options="result_options" />
          <ml-input v-else class="w-full" v-model="form.subInfo[value]" />
        </div>
      </template>
    </write-grid-container>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import { required } from "vuelidate/lib/validators";

import FileUploader from "@/components/FileUploader.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector";

export default {
  components: {
    FileUploader,
    CustomOptionSelector,
    WriteGridContainer,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
    },
  },
  data() {
    return {
      result_options: ["크레인", "크레인(리모콘)", "지게차"],
      gridContainerOptions: {
        dataTypes: ["string", "string", "selector", "string", "file"],
        labels: ["팀명", "이름", "구분", "자격번호", "자격증 첨부"],
        values: ["팀명", "이름", "구분", "자격번호", "자격증첨부"],
      },
      form: {
        stdInfo: {},
        fileList: [],
        subInfo: {
          팀명: "",
          이름: "",
          구분: "",
          자격번호: "",
          자격증첨부: {},
        },
      },
    };
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    // subInfo 초기화
    this.form.subInfo = this.gridContainerOptions.values.reduce((acc, cur) => {
      acc[cur] = "";
      return acc;
    }, {});

    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "사업장명을 반드시 입력해야 합니다";
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
